import * as Types from '../../../@types/graphql-types';

import gql from 'graphql-tag';
import { SponsoredAdSportFragmentFragmentDoc } from '../fragments/SponsoredAdSport.fragment';
export type GetSportsEventsListQueryVariables = Types.Exact<{
	allowSponsoredRecommendations?: Types.InputMaybe<Types.SponsoredRecommendationsInput>;
	country: Types.Scalars['Country']['input'];
	filter?: Types.InputMaybe<Types.SportEventFilter>;
	language: Types.Scalars['Language']['input'];
	platform?: Types.Platform;
	timezoneOffset: Types.Scalars['Int']['input'];
}>;

export type GetSportsEventsListQuery = {
	__typename?: 'Query';
	sportEventsV2: {
		__typename?: 'SportEventsConnectionV2';
		sponsoredAd?: {
			__typename?: 'SponsoredRecommendationAd';
			bidId: string;
			holdoutGroup: boolean;
			campaign: {
				__typename?: 'SponsoredRecommendationCampaign';
				promotionalImageUrl?: string | null;
				watchNowLabel?: string | null;
				watchNowOffer: { __typename?: 'Offer'; standardWebURL?: string | null };
				node:
					| { __typename?: 'Article' }
					| { __typename?: 'Author' }
					| { __typename?: 'Bundle' }
					| { __typename?: 'Device' }
					| { __typename?: 'Episode' }
					| { __typename?: 'GenericTitleList' }
					| { __typename?: 'Genre' }
					| { __typename?: 'Movie' }
					| { __typename?: 'MultiStepSportEvent' }
					| { __typename?: 'Offer' }
					| { __typename?: 'Package' }
					| { __typename?: 'Page' }
					| { __typename?: 'Person' }
					| { __typename?: 'Season' }
					| { __typename?: 'Show' }
					| {
							__typename?: 'SingleStepSportEvent';
							id: string;
							sport: Types.SportType;
							objectType: Types.ObjectType;
							objectId: number;
							offerCount: number;
							offers: Array<{
								__typename?: 'SportOffer';
								package: { __typename?: 'Package'; packageId: number };
							}>;
							competition?: {
								__typename?: 'SportCompetitionV2';
								id: string;
								objectId: number;
								activeSeason?: { __typename?: 'SportSeason'; name: string; seasonID: number } | null;
								content: {
									__typename?: 'SportCompetitionContentV2';
									fullPath: string;
									name: string;
									iconUrl?: string | null;
								};
							} | null;
							competitors: {
								__typename?: 'SingleStepSportCompetitorsV2';
								awayTeam: {
									__typename?: 'SingleStepSportCompetitorV2';
									score?: number | null;
									winner: boolean;
									competitors: Array<{
										__typename?: 'SportCompetitorV2';
										id: string;
										objectId: number;
										content: {
											__typename?: 'SportCompetitorContentV2';
											name: string;
											iconUrl?: string | null;
											fullPath?: string | null;
										};
									}>;
								};
								homeTeam: {
									__typename?: 'SingleStepSportCompetitorV2';
									score?: number | null;
									winner: boolean;
									competitors: Array<{
										__typename?: 'SportCompetitorV2';
										id: string;
										objectId: number;
										content: {
											__typename?: 'SportCompetitorContentV2';
											name: string;
											iconUrl?: string | null;
											fullPath?: string | null;
										};
									}>;
								};
							};
							content: {
								__typename?: 'SingleStepSportEventContent';
								name: string;
								fullPath?: string | null;
								status: Types.SportEventStatus;
								startAt: any;
								endAt?: any | null;
								venue?: { __typename?: 'SportVenue'; venueID: number } | null;
								competitionStage: {
									__typename?: 'SportCompetitionStageV2';
									name: Types.SportCompetitionStageName;
									number?: number | null;
								};
							};
					  }
					| { __typename?: 'SportCompetitionV2' }
					| { __typename?: 'SportCompetitorV2' }
					| { __typename?: 'Url' };
			};
		} | null;
		edges?: Array<{
			__typename?: 'SportEventsEdgeV2';
			node:
				| { __typename?: 'MultiStepSportEvent'; id: string }
				| {
						__typename?: 'SingleStepSportEvent';
						id: string;
						content: {
							__typename?: 'SingleStepSportEventContent';
							endAt?: any | null;
							fullPath?: string | null;
							name: string;
							startAt: any;
							status: Types.SportEventStatus;
						};
						competitors: {
							__typename?: 'SingleStepSportCompetitorsV2';
							awayTeam: {
								__typename?: 'SingleStepSportCompetitorV2';
								score?: number | null;
								winner: boolean;
								competitors: Array<{
									__typename?: 'SportCompetitorV2';
									content: {
										__typename?: 'SportCompetitorContentV2';
										name: string;
										iconUrl?: string | null;
										fullPath?: string | null;
									};
								}>;
							};
							homeTeam: {
								__typename?: 'SingleStepSportCompetitorV2';
								score?: number | null;
								winner: boolean;
								competitors: Array<{
									__typename?: 'SportCompetitorV2';
									content: {
										__typename?: 'SportCompetitorContentV2';
										name: string;
										iconUrl?: string | null;
										fullPath?: string | null;
									};
								}>;
							};
						};
						competition?: {
							__typename?: 'SportCompetitionV2';
							id: string;
							objectId: number;
							objectType: Types.ObjectType;
							content: {
								__typename?: 'SportCompetitionContentV2';
								name: string;
								fullPath: string;
								iconUrl?: string | null;
							};
						} | null;
				  };
		}> | null;
	};
};

export const GetSportsEventsListDocument = gql`
	query GetSportsEventsList(
		$allowSponsoredRecommendations: SponsoredRecommendationsInput
		$country: Country!
		$filter: SportEventFilter
		$language: Language!
		$platform: Platform! = WEB
		$timezoneOffset: Int!
	) {
		sportEventsV2(
			allowSponsoredRecommendations: $allowSponsoredRecommendations
			country: $country
			filter: $filter
			timezoneOffset: $timezoneOffset
		) {
			sponsoredAd {
				...SponsoredAdSportFragment
			}
			edges {
				node {
					id
					... on SingleStepSportEvent {
						content(country: $country, language: $language) {
							endAt
							fullPath
							name
							startAt
							status
						}
						competitors {
							awayTeam {
								score
								winner
								competitors {
									content(country: $country, language: $language) {
										name
										iconUrl
										fullPath
									}
								}
							}
							homeTeam {
								score
								winner
								competitors {
									content(country: $country, language: $language) {
										name
										iconUrl
										fullPath
									}
								}
							}
						}
						competition {
							id
							objectId
							objectType
							content(country: $country, language: $language) {
								name
								fullPath
								iconUrl
							}
						}
					}
				}
			}
		}
	}
	${SponsoredAdSportFragmentFragmentDoc}
`;
